import React from 'react';
import { useState } from "react";
import { SearchBox, SearchContainer } from "./styles";
import { useLanguage } from "src/hooks/Language";
import { FaSearch } from "react-icons/fa";

interface IPropsInput {
   
    name: string;
    titles: Record<string, any>;
    filter?: Record<string, any>;
  changeFilter : Function;
}


interface IPropsSelect {
    list: Record<string, any>[];
    name: string;
    titles: Record<string, any>;
    filter?: Record<string, any>;
  changeFilter : Function;
}

const SelectFilter : React.FC<IPropsSelect> = ({changeFilter, list, name, titles, filter  }) => {

  

const {language,translateProperty } = useLanguage();

 const translateAllField = {
  title: 'Todos',
  title_en : 'All',
title_es : 'Todos'
 }

 return <SearchContainer>
<p>{translateProperty({item: titles, property : 'title', language}) }</p>
          <select name={name} onChange={(e) => {  changeFilter(name,e?.target?.value)    }}>
      <option selected={!filter?.[name]} value={''}>{translateProperty({item: translateAllField, property : 'title', language}) }</option>
            {list?.map( item => {
                   return <option selected={filter?.[name] === item?.value} value={item?.value}>{item?.label}</option>
            })}
          </select> 
          </SearchContainer>



}

const InputFilter : React.FC<IPropsInput> = ({changeFilter,   name, titles, filter  }) => {

  const [search, setSearch] = useState('');

const {language,translateProperty } = useLanguage();

 const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      changeFilter('search', search);
    }
  };

 return <SearchContainer>
<p style={{color: '#fff'}}>{translateProperty({item: titles, property : 'title', language}) }</p>
       <div className='row gap-xs'>  <input name={name} style={{padding: '10px', color:'#333', border: '1px solid #333'}} onKeyDown={handleKeyDown} onChange={(e) => setSearch(e?.target?.value)} value={search}/>
    <button onClick={() => { changeFilter('search',search)}} className='greenButton3'>
        <FaSearch size={20}/>
    </button>
    </div>   
          </SearchContainer>



}


const SearchContainerComponent = ({configs, searchList, changeFilter, component_styles, filter}) => {
 
return <SearchBox>


  {searchList.map( item => {

    if(item?.type === 'search'){

      return <InputFilter name={item?.name} filter={filter} changeFilter={changeFilter} 
  titles={item?.titles}/>
      

    }
    else if(item?.type === 'select'){
      

         return <SelectFilter name={item?.name}  filter={filter} changeFilter={changeFilter} list={item?.list || []} 
        titles={item?.titles}/>


    }




  })}
 


 
    </SearchBox>



}


export default SearchContainerComponent;